import apiClient from '../../../services/api';

const hostService = {
    getHosts: async (params = {}) => {
        const query = new URLSearchParams(params).toString();
        const response = await apiClient.get(`/hosts?${query}`);
        return response.data.data;
    },

    getHostById: async (hostId) => {
        const response = await apiClient.get(`/hosts/${hostId}`);
        return response.data.data;
    },

    addHost: async (credentials) => {
        // credentials: { email, password, twoFaSecret }
        const response = await apiClient.post('/hosts', credentials);
        return response.data;
    },

    deleteHost: async (hostId) => {
        const response = await apiClient.delete(`/hosts/${hostId}`);
        return response.data;
    },

    updateHost: async (hostId, data) => {
        const response = await apiClient.patch(`/hosts/${hostId}`, data);
        return response.data;
    },

    refreshHostToken: async (hostId) => {
        const response = await apiClient.post(`/hosts/${hostId}/refresh-token`);
        return response.data;
    },

    bulkAddHosts: async (credentialsList) => {
        const response = await apiClient.post('/hosts/bulk', { credentialsList });
        return response.data;
    },

    getBulkProgress: async () => {
        const response = await apiClient.get('/hosts/bulk/progress');
        return response.data;
    },

    cancelBulkAdd: async () => {
        const response = await apiClient.post('/hosts/bulk/cancel');
        return response.data;
    },
};

export default hostService;
